import { GameListProps } from './props';
import { memo, useMemo } from 'react';
import styles from './styles.module.scss';
import GameCard from '../GameCard/Versions/Primary';
import { ErrorCard, NoDataComponent } from '@starsoft/common/components';

function GameList({
  games,
  error,
  isLoading,
  isFetchingNextPage,
  refetch,
}: GameListProps) {
  const Games = useMemo(
    () =>
      games?.map(game => (
        <GameCard key={`slot-game-${game?.id}`} game={game} />
      )),
    [games],
  );

  const Skeletons = useMemo(
    () =>
      Array.from({ length: 50 }).map((_, index) => (
        <GameCard key={`slot-game-card-skeleton-${index}`} isLoading />
      )),
    [],
  );

  if (error) {
    return <ErrorCard error={error} refetch={refetch} />;
  }

  if (games?.length == 0 && !isLoading) {
    return <NoDataComponent />;
  }

  return (
    <div className={styles.container}>
      {isLoading ? Skeletons : Games}
      {isFetchingNextPage && Skeletons}
    </div>
  );
}

export default memo(GameList);
